export class AdminPaymentChartController {
  constructor($scope, PaymentService, $timeout, toastr) {
    this.scope = $scope;
    this.timeout = $timeout;
    this.toastr = toastr;
    this.PaymentService = PaymentService;

    this.init();
  }

  init() {
    this.scope.series = ['Disactive', 'Active', 'Pending', 'rechazado'];
    this.scope.chartBar = {data: [], labels: []};
    this.scope.chartPieGender = {data: [], labels: []};
    this.scope.chartPieAge = {data: [], labels: []};
    this.scope.chartPiePaymentsNumber = {data: [], labels: []};
    this.scope.chartPiePaymentsTotal = {data: [], labels: []};

    this.scope.options = {
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false,
    };

    this.scope.months = [
      {name: 'January', id: 0},
      {name: 'February', id: 1},
      {name: 'March', id: 2},
      {name: 'April', id: 3},
      {name: 'May', id: 4},
      {name: 'June', id: 5},
      {name: 'July', id: 6},
      {name: 'August', id: 7},
      {name: 'September', id: 8},
      {name: 'October', id: 9},
      {name: 'November', id: 10},
      {name: 'December', id: 11}
    ];

    this.scope.yearsNums = [];

    for(let i = 2016; i <= new Date().getFullYear(); i++) {
      this.scope.yearsNums.push(i);
    }

    this.scope.filters = {
      method: {paypal: true, webpay: true, servipag: true, manual: true},
      gender: {male: true, female: true}
    };

    this.scope.currentDateSelector = {
      loading: false,
      exporting: false,
      type: 'day',
      view: 'hour',
      day: {
        model: new Date(),
        options: {
          datepickerMode: 'day',
          showWeeks: false,
          startingDay: 1
        }
      },
      week: {
        model: new Date(),
        options: {
          datepickerMode: 'day',
          showWeeks: true,
          startingDay: 1
        }
      },
      month: {
        model: {
          month: this.scope.months[new Date().getMonth()].id.toString(),
          year: this.scope.yearsNums[this.scope.yearsNums.length - 1]
        }
      },
      year: {
        model: this.scope.yearsNums[this.scope.yearsNums.length - 1]
      },
      range: {
        from: {
          options: {
            showWeeks: false,
            startingDay: 1
          },
          model: new Date()
        },
        to: {
          options: {
            showWeeks: false,
            startingDay: 1,
            minDate: new Date()
          },
          model: new Date().setDate(new Date().getDate() + 1)
        }
      }
    };

    this.scope.selectFor = (type) => {
      this.scope.currentDateSelector.type = type;
    };

    this.scope.selectBy = (type) => {
      this.scope.currentDateSelector.view = type;
    };

    this.scope.getData = () => {
      this.scope.total = {
        chart: 0,
        transactions: 0,
        users: 0
      }
      this.scope.currentDateSelector.loading = true;
      let options = this.getRange();
      options.filters = this.scope.filters;
      options.filters.filteredAge = this.getFilterAge(this.scope.filters.age);
      this.PaymentService.getPaymentChart(options)
        .then((response) => { let data = response.data;

          this.PaymentService.getPaymentCountByUsers({users:data.data.paymentsUser, timeFrom:options.from})
            .then((response) => { let res = response.data;
          this.scope.total = data.data.total;
          this.scope.chartBar.labels = [];
          this.scope.chartBar.data = [[], []];
          this.scope.chartPieGender.labels = [];
          this.scope.chartPieGender.data = [];
          this.scope.chartPieAge.labels = [];
          this.scope.chartPieAge.data = [];
          this.scope.chartPiePaymentsNumber.labels = [];
          this.scope.chartPiePaymentsNumber.data = [];          
          this.scope.chartPiePaymentsTotal.labels = [];
          this.scope.chartPiePaymentsTotal.data = [];

          _.forEach(data.data.gender, (value, key) => {
            this.scope.chartPieGender.labels.push(key);
            this.scope.chartPieGender.data.push(value);
          });
          _.forEach(data.data.age, (value, key) => {
            this.scope.chartPieAge.labels.push(key);
            this.scope.chartPieAge.data.push(value);
          });
          _.forEach(data.data.results, (dataSet, dataKey) => {
            let dayOfYear = moment.utc().dayOfYear(dataSet.dayOfYear);
            let createdAt = moment.utc(dataSet.created_at);
            switch(data.data.type) {
              case 'day': 
              case 'week':              
              case 'month':
              case 'range':
                if(data.data.group == 'hour'){
                  this.scope.chartBar.labels.push(`${dataSet.hour}:00`);
                  break;
                } else {
                  this.scope.chartBar.labels.push(`${dayOfYear.date()} of ${this.getMonth(dayOfYear.month() + 1)}, ${dayOfYear.year()}`);
                  break;
                }
              case 'year':
                this.scope.chartBar.labels.push(`${this.getMonth(createdAt.month() + 1)}, ${createdAt.year()}`);
            }

            _.forEach(dataSet.status, (statusArr, statusKey) => {
              this.scope.chartBar.data[statusKey].push(statusArr.length);
            });

            for(let i = 0; i <= 1; i++){
              if(!this.scope.chartBar.data[i][dataKey]) this.scope.chartBar.data[i].push(0)
            }

          });
              _.forEach(res.paymentCountByNumber, (value, key) => {
                this.scope.chartPiePaymentsNumber.labels.push(key);
                this.scope.chartPiePaymentsNumber.data.push(value);
              });
              _.forEach(res.paymentCountTotal, (value, key) => {
                this.scope.chartPiePaymentsTotal.labels.push(key);
                this.scope.chartPiePaymentsTotal.data.push(value);
              });

              this.scope.currentDateSelector.loading = false;
            })
            .catch((response) => { let err = response.data;
              console.error(err);
            })


        })
        .catch((response) => { let err = response.data;
          this.scope.currentDateSelector.loading = false;
          console.error(err);
        });
    };

    this.scope.exportExcel = () => {
      this.scope.total = 0;
      this.toastr.info('Getting data from the server', 'Information');
      this.scope.currentDateSelector.exporting = true;
      let options = this.getRange();
      options.filters = this.scope.filters;
      options.filters.filteredAge = this.getFilterAge(this.scope.filters.age);
      this.PaymentService.getPaymentChartExport(options)
        .then((response) => { let data = response.data;
          this.toastr.info('Preparing data', 'Information');
          _.forEach(data.data, (payment) => {
            payment.created_at = new Date(payment.created_at);

            switch(payment.status) {
              case 0:
                payment.status = 'Disactive';
                break;
              case 1:
                payment.status = 'Active';
                break;
            }
          });

          this.scope.usersPayments = data.data;
          for(var i = 0; i < this.scope.usersPayments.length; i++){
            var payment = this.scope.usersPayments[i];
            this.scope.total += payment.fee;
          }
          console.log(this.scope.total);
          this.timeout(() => {
            var blob = new Blob([document.getElementById('exportable').innerHTML], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            });
            FileSaver.saveAs(blob, "Report.xls");

            this.scope.currentDateSelector.exporting = false;
            this.toastr.success('Data exported to Report.xls!', 'Success');
          })
        })
        .catch((response) => { let err = response.data;
          this.scope.currentDateSelector.exporting = false;
          this.toastr.error('Something went wrong. Please, select a shorter date range or try later.', 'Error');
          console.error(err);
        });
    };

    this.scope.$watch('currentDateSelector.range.from.model', (val) => {
      switch (this.scope.currentDateSelector.type) {
        case 'range':
          this.scope.currentDateSelector.range.to.options.minDate = this.scope.currentDateSelector.range.from.model;

          if(this.scope.currentDateSelector.range.to.model <= this.scope.currentDateSelector.range.from.model) {
            this.scope.currentDateSelector.range.to.model = new Date(this.scope.currentDateSelector.range.from.model).setDate(new Date(this.scope.currentDateSelector.range.from.model).getDate() + 1)
          }
          break;
      }
    });

    this.scope.getData();
  }

  getRange() {
    switch(this.scope.currentDateSelector.type) {
      case 'day':
        return {
          from: moment.utc(this.scope.currentDateSelector.day.model).startOf('day').toISOString(),
          to: moment.utc(this.scope.currentDateSelector.day.model).endOf('day').toISOString(),
          group: this.scope.currentDateSelector.view,
          type: 'day'
        };
      case 'week':
        return {
          from: moment.utc(this.scope.currentDateSelector.week.model).startOf('week').toISOString(),
          to: moment.utc(this.scope.currentDateSelector.week.model).endOf('week').toISOString(),
          group: this.scope.currentDateSelector.view,
          type: 'week'
        };
      case 'month':
        return {
          from: moment.utc(`${this.scope.currentDateSelector.month.model.year}-${parseInt(this.scope.currentDateSelector.month.model.month) + 1}`, "YYYY-M").startOf('month').toISOString(),
          to: moment.utc(`${this.scope.currentDateSelector.month.model.year}-${parseInt(this.scope.currentDateSelector.month.model.month) + 1}`, "YYYY-M").endOf('month').toISOString(),
          group: this.scope.currentDateSelector.view,
          type: 'month'
        };
      case 'year':
        return {
          from: moment.utc(`${this.scope.currentDateSelector.year.model}`, "YYYY").startOf('year').toISOString(),
          to: moment.utc(`${this.scope.currentDateSelector.year.model}`, "YYYY").endOf('year').toISOString(),
          group: 'month',
          type: 'year'
        };
      case 'range':
        return {
          from: moment.utc(this.scope.currentDateSelector.range.from.model).startOf('day').toISOString(),
          to: moment.utc(this.scope.currentDateSelector.range.to.model).endOf('day').toISOString(),
          group: this.scope.currentDateSelector.view,
          type: 'range'
        };
      default:
        return {
          group: 'month',
          type: 'norange'
        };
    }
  }

  getMonth(month) {
    switch (month) {
      case 1: return "January";
      case 2: return "February";
      case 3: return "March";
      case 4: return "April";
      case 5: return "May";
      case 6: return "June";
      case 7: return "July";
      case 8: return "August";
      case 9: return "September";
      case 10: return "October";
      case 11: return "November";
      case 12: return "December";
    }
  }

  getFilterAge(param) {
    switch (param) {
      case '1': return {from: 18, to: 20};
      case '2': return {from: 21, to: 30};
      case '3': return {from: 31, to: 40};
      case '4': return {from: 41, to: 50};
      case '5': return {from: 51, to: 60};
      case '6': return {from: 61, to: 100};
      case '7': 
      if(this.scope.filters.rangeAgeFrom < 18)  this.scope.filters.rangeAgeFrom = 18;
      if(this.scope.filters.rangeAgeTo > 100)  this.scope.filters.rangeAgeTo = 100;
      if(this.scope.filters.rangeAgeTo < this.scope.filters.rangeAgeFrom) this.scope.filters.rangeAgeTo = this.scope.filters.rangeAgeFrom + 1;
      return {from: this.scope.filters.rangeAgeFrom, to: this.scope.filters.rangeAgeTo};
      default: return {from: 18, to: 100};
    }
  }
}
